<template lang="pug">
.checkout-page
  Breadcrumbs(:list="breadcrumbs")
  InlineSvg.checkout-page__back(:src="require('~/assets/img/icons/angle-left.svg')" @click="goBack")

  h1.checkout-page__h1(v-t="'checkout'")

  .checkout-page__main
    .checkout-page__block
      .checkout-page__title {{ $t("buyersDetails") }}

      .checkout-page__fields
        .checkout-page__field
          .checkout-page__field-label {{ $t("firstName") }}*
          FormInput(v-model="name")
        .checkout-page__field
          .checkout-page__field-label {{ $t("lastName") }}*
          FormInput(v-model="surname")
        .checkout-page__field
          .checkout-page__field-label E-mail*
          FormInput(v-model="email")
        .checkout-page__field
          .checkout-page__field-label {{ $t("phone") }}*
          FormInput(v-model="phone")

      .checkout-page__title {{ $t("deliveryAddress") }}

      .checkout-page__fields
        .checkout-page__field
          .checkout-page__field-label {{ $t("country") }}*
          BaseSelect(
            :options="countries"
            :value="countryCode"
            :with-empty-value="false"
            @input="onCountryChange($event)"
          )
            span {{ country }}
        .checkout-page__field
          .checkout-page__field-label {{ $t("region") }}*
          FormInput(v-model="region")
        .checkout-page__field
          .checkout-page__field-label {{ $t("city") }}*
          FormInput(v-model="city")
        .checkout-page__field
          .checkout-page__field-label {{ $t("addressText") }}*
          FormInput(v-model="addressText")
        .checkout-page__field
          .checkout-page__field-label {{ $t("apartments") }}
          FormInput(v-model="apartments")
        .checkout-page__field
          .checkout-page__field-label {{ $t("postalCode") }}*
          FormInput(v-model="postalCode")
        .checkout-page__label * - {{ $t("requiredField") }}

      .checkout-page__title {{ $t("payMethod") }}

      .checkout-page__fields.checkout-page__fields--no-border
        .checkout-page__field
          BaseSelect(
            :options="payMethods"
            v-model="payMethod"
            :with-empty-value="false"
          )
            span {{ country }}

    .checkout-page__block
      .checkout-page__title
        span {{ $t("payMethod") }}
        span.checkout-page__title-additional {{ $t("nItems", {n: count}) }}

      .checkout-page__fields
        .checkout-page__product(v-for="item in cartItems")
          span.checkout-page__product-name {{ item.title }} •&nbsp;
            span.checkout-page__product-amount {{ $t("nPcs", {n: amountInCart(item)}) }}
          Currency(type="money" size="16" is-reversed real)
            span.checkout-page__product-price {{ (item.max_price / 100).toFixed(2).replace('.00', '') }}

      .checkout-page__fields
        .checkout-page__pair
          .checkout-page__pair-key {{ $t("paymentInCoins") }}
          Currency(type="coins" size="16" is-reversed)
            .checkout-page__pair-value {{ coins }}
        .checkout-page__pair
          .checkout-page__pair-key {{ $t("priceWithDiscount") }}
          Currency(type="money" size="16" is-reversed real)
            .checkout-page__pair-value {{ total }}
        .checkout-page__pair.checkout-page__pair--sub
          .checkout-page__pair-key {{ $t("priceWithDiscountNET") }}
          Currency(type="money" size="16" is-reversed real)
            .checkout-page__pair-value {{ priceWithoutVAT }}
        .checkout-page__pair.checkout-page__pair--sub
          .checkout-page__pair-key {{ $t("includingVAT") }} ({{ vatPercent || '?' }})
          Currency(type="money" size="16" is-reversed real)
            .checkout-page__pair-value
              | {{ vat || '___' }}
        .checkout-page__pair
          .checkout-page__pair-key {{ $t("shippingCost") }}
          Currency(type="money" size="16" is-reversed real)
            .checkout-page__pair-value {{ shippingCost || '___' }}

      .checkout-page__fields.checkout-page__fields--no-border
        .checkout-page__pair
          .checkout-page__pair-key--big {{ $t("totalPay") }}:
          Currency(type="money" size="16" is-reversed real)
            .checkout-page__pair-value {{ totalWithVATAndShipping || '___' }}

        .checkout-page__warning(v-if="nonEU" v-t="'warningShopNonEUCountries'")

        .checkout-page__checkbox
          CheckboxInput(v-model="checkbox")
          span.checkout-page__checkbox-label(v-html="$t('marketplaceCheckoutCheckboxText')")

        Button.checkout-page__button(is-primary :disabled="checkoutButtonDisabled" @click="pay") {{ $t("payWithCard") }}

        p.checkout-page__address {{$t('ourCompanyAddress')}}: Solian Enterprises Limited. Registered number: HE 412444. Emmanouil road 44, KIRZIS CENTER, 3031 Limassol, Cyprus
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs'
import FormInput from '~/components/FormInput/FormInput'
import CheckboxInput from '~/components/CheckboxInput/CheckboxInput'
import BaseSelect from '~/components/BaseSelect/BaseSelect'
import StoreService from '~/services/StoreService'
import { countryByCode, allCountries } from '~/utils/country'

export default {
  components: {
    Breadcrumbs,
    FormInput,
    BaseSelect,
    CheckboxInput
  },

  data () {
    return {
      cart: undefined,
      checkbox: false,
      name: '',
      surname: '',
      email: '',
      phone: '',
      countryCode: '',
      region: '',
      city: '',
      addressText: '',
      apartments: '',
      postalCode: '',
      payMethod: 'creditCard',
      payMethods: [
        {
          title: this.$t('creditCard'),
          value: 'creditCard'
        }
      ],
      euCountries: ['AT', 'BE', 'BG', 'HU', 'DE', 'GR', 'DK', 'IE', 'ES', 'IT', 'CY', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'FI', 'FR', 'HR', 'CZ', 'SE', 'EE'],
      availableCountries: ['AT', 'BE', 'BA', 'BG', 'HR', 'CY', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LI', 'LT', 'LU', 'NL', 'PL', 'PT', 'RO', 'RS', 'SI', 'ES', 'SE', 'CH', 'UA', 'UK', 'SK', 'CZ', 'KZ'],
      shippingCosts3: {
        AT: 4.3,
        BE: 4.95,
        BA: 32.79,
        BG: 7.65,
        HR: 4.95,
        CY: 16.05,
        DK: 4.95,
        EE: 6.35,
        FI: 10.70,
        FR: 7.95,
        DE: 4.35,
        GR: 8.60,
        HU: 4.55,
        IE: 10.65,
        IT: 7.65,
        LV: 6.25,
        LI: 10.60,
        LT: 6.70,
        LU: 4.95,
        NL: 4.95,
        PL: 3.65,
        PT: 8.80,
        RO: 6.20,
        SR: 33.86,
        SI: 6.25,
        ES: 8.80,
        SE: 7.65,
        CH: 10.65,
        UK: 13.35,
        SK: 4.05,
        CZ: 2.85,
        KZ: 4.95,
        UA: 11.20
      },
      shippingCosts10: {
        AT: 6.35,
        BE: 7.20,
        BA: 47.90,
        BG: 11.50,
        HR: 7.20,
        CY: 27.50,
        DK: 7.90,
        EE: 7.40,
        FI: 14.32,
        FR: 11.55,
        DE: 6.10,
        GR: 11.50,
        HU: 6.35,
        IE: 16.84,
        IT: 10.38,
        LV: 8.65,
        LI: 16.80,
        LT: 8.60,
        LU: 7.20,
        NL: 7.20,
        PL: 5.40,
        PT: 9.90,
        RO: 8.65,
        SR: 33.86,
        SI: 8.10,
        ES: 10.90,
        SE: 11.55,
        CH: 12.10,
        UK: 13.35,
        SK: 5.10,
        CZ: 3.10,
        KZ: 45.11,
        UA: 20.30
      },
      shippingCosts30: {
        AT: 8.20,
        BE: 9.80,
        BA: 77.68,
        BG: 13.50,
        HR: 9.90,
        CY: 75.50,
        DK: 9.80,
        EE: 11.80,
        FI: 25.32,
        FR: 13.35,
        DE: 8.33,
        GR: 77.68,
        HU: 8.55,
        IE: 23.80,
        IT: 13.40,
        LV: 11.50,
        LI: 23.80,
        LT: 11.50,
        LU: 9.80,
        NL: 9.90,
        PL: 6.60,
        PT: 20.70,
        RO: 11.55,
        SR: 33.86,
        SI: 11.50,
        ES: 20.70,
        SE: 13.35,
        CH: 23.80,
        UK: 13.35,
        SK: 6.60,
        CZ: 4.50,
        KZ: 105.10,
        UA: 30.10
      },
      vatRates: {
        AL: 20,
        DZ: 19,
        AO: 14,
        AR: 21,
        AM: 20,
        AU: 10,
        AT: 20,
        AZ: 18,
        BH: 5,
        BB: 17.5,
        BY: 20,
        BE: 21,
        BM: 0,
        BO: 13,
        BA: 0, // 17
        BW: 12,
        BR: 20,
        BG: 20,
        CV: 15,
        KH: 10,
        CM: 19.25,
        CA: 15,
        KY: 0,
        TD: 18,
        CN: 13,
        CO: 19,
        CD: 16,
        CG: 18.9,
        CR: 13,
        HR: 25,
        CY: 19,
        CZ: 21,
        DK: 25,
        DO: 18,
        EC: 12,
        EG: 14,
        SV: 13,
        GQ: 15,
        EE: 20,
        SZ: 15,
        FJ: 9,
        FI: 24,
        FR: 20,
        GA: 18,
        GE: 18,
        DE: 19,
        GH: 12.5,
        GI: 0,
        GR: 24,
        GL: 0,
        GT: 12,
        GG: 0,
        GY: 14,
        HN: 15,
        HK: 0,
        HU: 27,
        IS: 24,
        IN: 18,
        ID: 10,
        IQ: 10,
        IE: 23,
        IM: 20,
        IL: 17,
        IT: 22,
        CI: 18,
        JM: 15,
        JP: 8,
        JE: 8,
        JO: 16,
        KZ: 0, // 12
        KE: 16,
        KR: 10,
        KW: 0,
        KG: 12,
        LA: 10,
        LV: 21,
        LB: 11,
        LY: 0,
        LI: 19, // 7.7
        LT: 21,
        LU: 17,
        MO: 0,
        MG: 20,
        MW: 16.5,
        MY: 16,
        MV: 6,
        MT: 18,
        MR: 16,
        MU: 15,
        MX: 16,
        MD: 20,
        MN: 10,
        ME: 21,
        MA: 20,
        MZ: 17,
        MM: 5,
        NA: 15,
        NL: 21,
        NZ: 15,
        NI: 15,
        NG: 7.5,
        NO: 19, // 25,
        OM: 5,
        PK: 17,
        PS: 16,
        PA: 7,
        PG: 10,
        PY: 10,
        PE: 18,
        PH: 12,
        PL: 23,
        PT: 23,
        PR: 11.5,
        QA: 0,
        RO: 19,
        RU: 20,
        RW: 18,
        LC: 12.5,
        SA: 15,
        SN: 18,
        RS: 0, // 20,
        SG: 7,
        SK: 20,
        SI: 22,
        ZA: 15,
        ES: 21,
        LK: 8,
        SE: 25,
        CH: 19, // 7.7
        TW: 5,
        TJ: 18,
        TZ: 18,
        TH: 7,
        TL: 2.5,
        TT: 12.5,
        TN: 19,
        TR: 18,
        TM: 15,
        UG: 18,
        UA: 20,
        AE: 5,
        GB: 20,
        US: 0,
        UY: 22,
        UZ: 15,
        VE: 16,
        VN: 10,
        ZM: 16,
        ZW: 14.5,
        AF: 10,
        IR: 25,
        UM: 15,
        CL: 19
      }
    }
  },

  computed: {
    checkoutButtonDisabled () {
      return !this.checkbox ||
        this.name === '' ||
        this.surname === '' ||
        this.email === '' ||
        this.phone === '' ||
        this.countryCode === '' ||
        this.region === '' ||
        this.city === '' ||
        this.addressText === '' ||
        this.postalCode === ''
    },
    breadcrumbs () {
      return [
        { title: this.$t('store'), to: '/store/marketplace' },
        { title: this.$t('checkout') }
      ]
    },

    countries () {
      return allCountries().filter(c => this.availableCountries.includes(c.value))
    },

    country () {
      return countryByCode(this.countryCode)
    },

    vatPercent () {
      return `${this.vatRates[this.countryCode] || ''}%`
    },

    vat () {
      const vat = this.total * this.vatRates[this.countryCode] / 100
      if (vat) {
        return vat.toFixed(2)
      }
      return undefined
    },

    priceWithoutVAT () {
      return (this.total - +(this.vat || 0)).toFixed(2).replace('.00', '')
    },

    shippingCost () {
      if (this.weight <= 3) {
        return this.shippingCosts3[this.countryCode]
      } else if (this.weight <= 10) {
        return this.shippingCosts10[this.countryCode]
      } else {
        return this.shippingCosts30[this.countryCode]
      }
    },

    totalWithVATAndShipping () {
      const result = +this.total + +this.shippingCost
      if (result) {
        return (result).toFixed(2).replace('.00', '')
      }
      return undefined
    },

    count () {
      return this.cart?.content?.items?.length
    },

    coins () {
      return this.cart?.content?.coins?.map(d => d.amount).reduce((b, a) => b + a, 0).toFixed(0)
    },

    total () {
      return (this.cart?.content?.total / 100).toFixed(2).replace('.00', '')
    },

    weight () {
      return this.cart?.content?.weight
    },

    cartItems () {
      return this.cart?.content?.items?.filter((item, index, array) => array.findIndex(n => n.id === item.id) === index)
    },

    nonEU () {
      return this.countryCode !== '' && !this.euCountries.includes(this.countryCode)
    }
  },

  mounted () {
    this.loadCart()
  },

  methods: {
    goBack () {
      this.$router.push(this.localeLocation('/store/cart'))
    },

    async loadCart () {
      this.cart = (await StoreService.getCart(this.$axios))?.data?.data?.cart
      console.log(this.cart)
      this.cartIsLoaded = true
    },

    onCountryChange (event) {
      this.countryCode = event
    },

    amountInCart (product) {
      return this.cart?.content?.items?.map(item => item.id).filter(item => item === product.id)?.length
    },

    pay () {
      if (!this.checkbox) {
        return
      }

      StoreService.createOrder(this.$axios, {
        firstname: this.name,
        lastname: this.surname,
        email: this.email,
        phone: this.phone,
        countryCode: this.countryCode,
        region: this.region,
        city: this.city,
        addressText: this.addressText,
        apartments: this.apartments,
        postalCode: this.postalCode,
        amount: +this.totalWithVATAndShipping
      }, `${location.protocol}//${location.host}/profile/orders`)
        .then((response) => {
          if (response.data?.data?.result?.returnUrl) {
            window.location.replace(response.data.data.result.returnUrl)
          }
        })
        .catch((err) => {
          this.isError = err.response?.data?.code || true
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.checkout-page {
  padding: 16px;

  @media (min-width: $breakpointDesktopWide) {
    padding: 44px 115px;
  }

  &__back {
    width: 24px;
    height: 24px;
    cursor: pointer;
  }

  &__main {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 24px;
    margin-top: 12px;

    @media (min-width: $breakpointDesktopWide) {
      grid-template-columns: 7fr 5fr;
    }
  }

  &__h1 {
    margin-bottom: 16px;
    color: $white;
    font-size: 24px;
    font-weight: 700;
    line-height: 32px;

    @media (min-width: $breakpointDesktopWide) {
      margin-top: 44px;
      margin-bottom: 27px;
      font-size: 32px;
      line-height: 36px;
    }
  }

  &__block {
    background: $blue-grey70;
    border-radius: 16px;
    height: max-content;
  }

  &__title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    color: $white;
    font-size: 20px;
    font-weight: 700;
    line-height: 24px;
    border-bottom: 1px solid $blue-grey40;

    &-additional {
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
    }
  }

  &__label {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: $blue-grey10;
  }

  &__fields {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 16px;
    padding: 16px;
    border-bottom: 1px solid $blue-grey40;

    &--no-border {
      border: none;
    }
  }

  &__field {
    &-label {
      margin-bottom: 4px;
      color: $blue-grey10;
      font-size: 12px;
      font-weight: 500;
      line-height: 100%;
      letter-spacing: 0.24px;
      text-transform: uppercase;
    }
  }

  &__product {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;

    &-name {
      color: $white;
      font-size: 14px;
      font-weight: 500;
      line-height: 18px;
    }

    &-amount {
      color: $blue-grey10;
      font-size: 14px;
      font-weight: 500;
      line-height: 18px;
    }

    &-price {
      color: $white;
      font-size: 14px;
      font-weight: 500;
      line-height: 18px;
    }
  }

  &__pair {
    display: flex;
    align-items: center;
    justify-content: space-between;

    &--sub {
      margin-left: 20px;
    }

    &-key {
      color: $blue-grey10;
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;

      &--big {
        color: $white;
        font-size: 20px;
        font-weight: 700;
        line-height: 28px;
      }
    }

    &-value {
      color: $white;
      font-size: 16px;
      font-weight: 700;
      line-height: 22px;
    }
  }

  &__checkbox {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;

    &-label {
      color: $white;
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
    }
  }

  &__button {
    width: 100%;

    &:disabled {
      opacity: 0.4;
    }
  }

  &__address {
    color: $blue-grey10;
    font-size: 12px;
    font-weight: 500;
    line-height: 18px;
  }

  &__warning {
    color: $red50;
    font-size: 12px;
    font-weight: 500;
    line-height: 18px;
  }
}
</style>
